<h3 mat-dialog-title>Filtrar Clientes Basket</h3>
<div mat-dialog-content style="width: 100%">

    
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Ativo</mat-label>
            <input matInput placeholder="Digite o ativo" aria-label="Ativo"  [formControl]="ativo" name="ativo" [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                    <span>Empresa: {{ativo.nome}}</span> |
                    <small>Sigla: {{ativo.sigla }}</small>
                </mat-option>
            </mat-autocomplete>            
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id == 7 || usuario.role_id == 4' fxFlex="100">
            <mat-label>Escritório</mat-label>
            <mat-select 
                placeholder="Escritório" 
                [(value)]="model.escritorio_id"
                [formControl]="escritorio_id" 
                (selectionChange)="selectEscritorio($event)">
                <mat-option value="">TODOS</mat-option>
                <mat-option *ngFor="let escritorio of listEscritorios"
                    [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        
        <mat-form-field appearance="outline" style="width: 100%" *ngIf='usuario.role_id != 5' fxFlex="100">
            <mat-label>Assessor</mat-label>
            <mat-select placeholder="Assessor"
                        [(value)]="model.assessor_id" 
                        [formControl]="assessor_id"
                        name="assessor_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
        </mat-form-field>
    
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>